export const GET_PERMISSIONS = "GET_PERMISSIONS";


export function getPermissions() {
  return { type: GET_PERMISSIONS };
}
